module.exports = __webpack_public_path__ + "static/servers1760x990-692a7fb26a2d9dcce5830a55579602a8.png";